export default __webpack_public_path__ + "static/media/blue-right-arrow.6dc521a6.svg";